import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { mainnet, sepolia } from '@reown/appkit/networks'

// 0. Setup queryClient
import { QueryClient } from '@tanstack/react-query'
export const queryClient = new QueryClient()

// 1. Get projectId from https://cloud.reown.com
const fallbackProjectId = 'f5da7f02952d50401f1b534cf1791410'
const projectId = process.env.REACT_APP_REOWN_PROJECT_ID || fallbackProjectId

if (!process.env.REACT_APP_REOWN_PROJECT_ID) {
  console.warn(
    'REACT_APP_REOWN_PROJECT_ID is not set. Using the built-in fallback project ID.'
  )
}

// 2. Create metadata object (simplified for React web)
const metadata = {
  name: 'Buan Fund',
  description: 'Buan Fund - Improving Biodiversity in Ireland',
  url: 'https://buanfund.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

// 3. Set the networks
const networks = [mainnet, sepolia]

// 4. Create Wagmi Adapter (React web uses WagmiAdapter, not defaultWagmiConfig)
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false // Set to false for client-side React app
})

// 5. Create modal with enhanced configuration matching mobile app features
export const modal = createAppKit({
  projectId,
  adapters: [wagmiAdapter], // React web uses adapters array
  networks: networks as any,
  defaultNetwork: mainnet,
  metadata,
  features: {
    // Disable email and social logins to prevent conflicts
    email: false,
    socials: [],
    // Show wallet options on first connect screen
    emailShowWallets: false,
    // Enable analytics
    analytics: true,
    // Disable onramp to prevent connection issues
    onramp: false
  },
  // Theme configuration
  themeMode: 'dark',
  themeVariables: {
    '--w3m-z-index': 9999
  },
  // Keep a tight, familiar wallet list for a simpler sign-in UX.
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust Wallet
    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369', // Rainbow
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa'  // Coinbase
  ],
  // Hide the long wallet directory (200+) and only show curated options.
  allWallets: 'HIDE',
  includeWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust Wallet
    '1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369', // Rainbow
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa'  // Coinbase
  ],
  excludeWalletIds: undefined,
  // Force SIWE + injected wallet flow (disable WalletConnect transport)
  enableWalletConnect: false,
  enableInjected: true, // Enable for mobile wallet browsers
  enableEIP6963: true,  // Enable for better wallet detection
  enableCoinbase: true,
  // Allow wallet connection from any chain — network enforcement happens only at
  // transaction time (EAS attestations require Ethereum mainnet/Sepolia).
  allowUnsupportedChain: true
})